import React from 'react';

const ArrowBottomIcon = () => {
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" viewBox="0 0 24 16">
    <g id="chevron-thin-right-blue" transform="translate(23.099 1) rotate(90)">
      <g id="Group_356" data-name="Group 356" transform="translate(-1 -1.04)">
        <rect id="canvas_background" width="16" height="24" transform="translate(0 0.139)" fill="none"/>
      </g>
      <g id="Group_357" data-name="Group 357" transform="translate(4.314 5.218)">
        <path id="chevron-thin-up" d="M5.794,6.788.159.932a.55.55,0,0,1,0-.772.537.537,0,0,1,.764,0L7.1,6.4a.55.55,0,0,1,0,.772L.923,13.414a.536.536,0,0,1-.764,0,.55.55,0,0,1,0-.772L5.794,6.788Z" transform="translate(0.237 0) rotate(1)" fill="#fff"/>
      </g>
    </g>
  </svg>
}
export default ArrowBottomIcon;
